import SearchIcon from '@mui/icons-material/Search'
import {InputAdornment, MenuItem, Stack, TextField} from '@mui/material'
import {Control, Controller} from 'react-hook-form'

import {FilterOption, FiltersFormValues, RoleFilterValue} from '../../types'

type SlaCommentsSearchFieldProps = {
  control: Control<FiltersFormValues>
  label: string
}

export const SlaCommentsSearchField = ({control, label}: SlaCommentsSearchFieldProps) => {
  return (
    <Controller
      name="searchTerm"
      control={control}
      render={({field}) => (
        <TextField
          fullWidth
          label={label}
          value={field.value}
          onChange={(event) => field.onChange(event.target.value)}
          inputRef={field.ref}
          name={field.name}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            )
          }}
        />
      )}
    />
  )
}

type SlaCommentsRoleFilterProps = {
  control: Control<FiltersFormValues>
  label: string
  options: FilterOption<RoleFilterValue>[]
}

export const SlaCommentsRoleFilter = ({control, label, options}: SlaCommentsRoleFilterProps) => {
  return (
    <Controller
      name="roleFilter"
      control={control}
      render={({field}) => (
        <TextField
          select
          fullWidth
          label={label}
          value={field.value}
          onChange={(event) => field.onChange(event.target.value as RoleFilterValue)}
          inputRef={field.ref}
          name={field.name}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )
}

type SlaCommentsKpiFilterProps = {
  control: Control<FiltersFormValues>
  label: string
  options: FilterOption[]
}

export const SlaCommentsKpiFilter = ({control, label, options}: SlaCommentsKpiFilterProps) => {
  return (
    <Controller
      name="kpiFilter"
      control={control}
      render={({field}) => (
        <TextField
          select
          fullWidth
          label={label}
          value={field.value}
          onChange={(event) => field.onChange(event.target.value)}
          inputRef={field.ref}
          name={field.name}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )
}

type SlaCommentsFiltersProps = {
  control: Control<FiltersFormValues>
  searchLabel: string
  roleLabel: string
  kpiLabel: string
  roleOptions: FilterOption<RoleFilterValue>[]
  kpiOptions: FilterOption[]
}

export const SlaCommentsFilters = ({
  control,
  searchLabel,
  roleLabel,
  kpiLabel,
  roleOptions,
  kpiOptions
}: SlaCommentsFiltersProps) => {
  return (
    <>
      <SlaCommentsSearchField control={control} label={searchLabel} />
      <Stack direction={{xs: 'column', md: 'row'}} spacing={2}>
        <SlaCommentsRoleFilter control={control} label={roleLabel} options={roleOptions} />
        <SlaCommentsKpiFilter control={control} label={kpiLabel} options={kpiOptions} />
      </Stack>
    </>
  )
}
